import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { LogInResult, User } from '../models/auth.models';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { RootStoreState } from '@app/root-store';
import { GetProjectsAction } from '@app/root-store/shared-store/project-store/actions';
import { Store } from '@ngrx/store';
import { GetProjectTypesAction } from '@app/root-store/project-type-store/actions';
import { HttpClient } from '@angular/common/http';
import { CurrentUserService } from '@surveyname/common';
import { take } from 'rxjs/operators';
import { Logout } from '@app/root-store/meta/actions';
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  constructor(
    private http: HttpClient,
    private currentUserService: CurrentUserService,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<RootStoreState.State>
  ) {}

  /**
   * Returns the current user
   */
  public currentUser(): User {
    return this.currentUserService.get();
  }

  login(email: string, password: string): Promise<LogInResult> {
    return new Promise((resolve, reject) => {
      const authData = { email, password };
      this.http
        .post<{ token: string; expiresIn: number; userDetails }>(
          environment.apiUrl + '/user/login',
          authData
        )
        .pipe(
          take(1)
        )
        .subscribe(
          (response) => {
            const token = response.token;
            if (token) {
              const user = response.userDetails;
              user.token = token;
              this.currentUserService.set(user);
              const returnUrl =
                this.route.snapshot.queryParams.returnUrl || '/project';
              this.router.navigate([returnUrl]);
            } else {
              resolve({message: 'Your email and password do not match. Please try again.'})
            }
          },
          (error) => {
            console.log(error);
            resolve({message: 'Can\'t login. Please try again.'})
          }
        );
    })
  }

  signup(user) {
    return this.http.post(environment.apiUrl + '/user/signup', user, {
      observe: 'response',
    });
  }
  postGoggleUser(user) {
    return this.http
      .post(environment.apiUrl + '/user/social-login', user)
      .subscribe(
        (response: any) => {
          const token = response.token;
          console.log('response', response);

          if (token) {
            const expiresInDuration = response.expiresIn;
            const user = response.userDetails;
            user.token = token;
            this.currentUserService.set(user);
            const userId = response.userDetails._id;
            const now = new Date();
            const expirationDate = new Date(
              now.getTime() + expiresInDuration * 1000
            );
            this.store.dispatch(GetProjectTypesAction());
            this.store.dispatch(GetProjectsAction());
            const returnUrl =
              this.route.snapshot.queryParams.returnUrl || '/project';
            this.router.navigate([returnUrl]);
          }
        },
        (error) => {
          console.log(error);
          //   this.authStatusListener.next(false);
        }
      );
  }
  /**
   * Logout the user
   */
  logout() {
    this.store.dispatch(new Logout());
    this.currentUserService.delete();
  }
}
